import plApp from "./pl/app.json";
import plLicenses from "./pl/licenses.json";
import plAdmin from "./pl/admin.json";
import enApp from "./en/app.json";
import enLicenses from "./en/licenses.json";
import enAdmin from "./en/admin.json";

// Tłumaczenia są podzielone na pliki obszarów (app, licenses, admin); każdy plik ma własne klucze najwyższego poziomu.
export const availableLocales = ["pl", "en"] as const;
export type AppLocale = typeof availableLocales[number];
export const defaultLocale: AppLocale = "pl";

const messages = {
    pl: { ...plApp, ...plLicenses, ...plAdmin },
    en: { ...enApp, ...enLicenses, ...enAdmin },
};

export default messages;
